import React from "react";
import ReactModal from "react-modal";
import LoadingAnimation from "../loadingAnimation/loadingAnimation";

import "./mainModal.scss";

export const MainModal = ({
  isOpen,
  onClose,
  parentSelector = "body",
  headerText,
  headerCloseHandler,
  containerClassName = "",
  children,
  primaryButtonText,
  primaryButtonClass,
  primaryButtonDisabled,
  primaryBtnHandler,
  secondaryBtnText,
  secondaryBtnClass,
  secondaryBtnHandler,
  width = 800,
  height = 540,
  swapFooter,
  isLoading = false,
  loadingClass = "",
  customStyles = {},
  renderFooter
}) => {
  const cName = containerClassName + " popup__container--dashboard";
  return (
    <ReactModal
      ariaHideApp={false}
      isOpen={isOpen}
      parentSelector={() => document.querySelector(parentSelector)}
      onRequestClose={onClose}
      shouldCloseOnOverlayClick
      portalClassName="popup"
      className={`popup__container ${cName}`}
      overlayClassName="popup__overlay"
      style={{
        content: {
          width,
          height,
          ...customStyles
        }
      }}
    >
      {isLoading ? (
        <LoadingAnimation height={height} customStyle={loadingClass} />
      ) : (
        <>
          {swapFooter ? (
            <Footer
              renderFooter={renderFooter}
              primaryButtonText={primaryButtonText}
              primaryButtonClass={primaryButtonClass}
              primaryButtonDisabled={primaryButtonDisabled}
              primaryBtnHandler={primaryBtnHandler}
              secondaryBtnText={secondaryBtnText}
              secondaryBtnClass={secondaryBtnClass}
              secondaryBtnHandler={secondaryBtnHandler}
            />
          ) : (
            <Header header={headerText} headerCloseHandler={headerCloseHandler} />
          )}

          <Body content={children} />
          {!swapFooter && (
            <Footer
              renderFooter={renderFooter}
              primaryButtonText={primaryButtonText}
              primaryButtonClass={primaryButtonClass}
              primaryButtonDisabled={primaryButtonDisabled}
              primaryBtnHandler={primaryBtnHandler}
              secondaryBtnText={secondaryBtnText}
              secondaryBtnClass={secondaryBtnClass}
              secondaryBtnHandler={secondaryBtnHandler}
            />
          )}
        </>
      )}
    </ReactModal>
  );
};

const Header = ({ header, headerCloseHandler }) => {
  if (!header) return null;
  return (
    <div className="popup__header" data-testid="popup-header">
      <h4>{header}</h4>
      <div className="popup__header__close" role="button" onClick={(e) => headerCloseHandler(e)}>
        x
      </div>
    </div>
  );
};

const Body = ({ content }) => {
  return (
    <div data-testid="popup-body" className="popup__body">
      {content}
    </div>
  );
};

const Footer = ({
  primaryButtonText,
  primaryButtonClass = "primary",
  primaryButtonDisabled,
  primaryBtnHandler,
  secondaryBtnText,
  secondaryBtnClass = "secondary",
  secondaryBtnHandler,
  renderFooter
}) => {
  return (
    <div className="popup__footer" data-testid="popup-footer">
      {renderFooter ? (
        renderFooter()
      ) : (
        <>
          {secondaryBtnText && (
            <button className={`button button--${secondaryBtnClass}`} onClick={secondaryBtnHandler}>
              {secondaryBtnText}
            </button>
          )}

          {primaryButtonText && (
            <button
              className={`button button--${primaryButtonClass}`}
              onClick={primaryBtnHandler}
              disabled={primaryButtonDisabled}
            >
              {primaryButtonText}
            </button>
          )}
        </>
      )}
    </div>
  );
};
